<ng-container [ngSwitch]="status">
  <app-card *ngSwitchCase="0" [type]="3" [title]="'Reset Password' | translate">
    <div cardBody3>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" vgFocusFirstInvalid [form]="resetPasswordForm">
        <div class="form-group">
          <label for="password"><i class="bi bi-key"></i> {{'common.label.newPassword' | translate }} </label>
          <input
            id="password"
            type="password"
            [placeholder]="'common.placeholder.newPassword' | translate "
            formControlName="newPassword"
            class="form-control"
          />
          <vg-error-section
            [label]="'common.label.newPassword' | translate"
            [group]="resetPasswordForm"
            controlName="newPassword"
          ></vg-error-section>
        </div>
        <div class="form-group">
          <label for="repeatedNewPassword"><i class="bi bi-key"></i> {{ 'common.label.repeatedNewPassword' | translate }}</label>
          <input
            id="repeatedNewPassword"
            type="password"
            [placeholder]="'common.placeholder.repeatedNewPassword' | translate"
            formControlName="repeatedNewPassword"
            class="form-control"
          />
          <vg-error-section
            [label]="'common.label.repeatedNewPassword' | translate"
            [group]="resetPasswordForm"
            controlName="repeatedNewPassword"
          ></vg-error-section>
        </div>
        <button [disabled]="loading" class="btn btn-primary rounded-pill float-right mt-2">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          <span>{{ 'Reset' | translate }}</span>
        </button>
      </form>
    </div>
  </app-card>
  <div class="alert alert-info text-center w-100 h-auto py-5" *ngIf="status === 1">
    {{ 'You will be brought back to the homepage after ' | translate }}<span>{{ countdownSec$ }}s<br /></span> {{ 'Or' | translate }}<br />
    [<a [routerLink]="['/home']">{{ 'Click here to return back to the home page' | translate }}</a>]
  </div>
  <div class="alert alert-danger text-center w-100 h-auto py-5" *ngSwitchCase="-1">
    <p>
      {{ 'Account activated failed' | translate }}<br />
      [<a [routerLink]="['/home']">{{ 'Click here to return back to the home page' | translate }}</a>]
    </p>
  </div>
</ng-container>
